/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TreeMapData } from './TreeMapData';
import { TreeMapDataFromJSON, TreeMapDataFromJSONTyped, TreeMapDataToJSON } from './TreeMapData';

/**
 *
 * @export
 * @interface TreeMapResponse
 */
export interface TreeMapResponse {
  /**
   *
   * @type {number}
   * @memberof TreeMapResponse
   */
  count: number;
  /**
   *
   * @type {Array<TreeMapData>}
   * @memberof TreeMapResponse
   */
  results: Array<TreeMapData>;
}

/**
 * Check if a given object implements the TreeMapResponse interface.
 */
export function instanceOfTreeMapResponse(value: object): value is TreeMapResponse {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function TreeMapResponseFromJSON(json: any): TreeMapResponse {
  return TreeMapResponseFromJSONTyped(json, false);
}

export function TreeMapResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TreeMapResponse {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    results: (json['results'] as Array<any>).map(TreeMapDataFromJSON),
  };
}

export function TreeMapResponseToJSON(value?: TreeMapResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    results: (value['results'] as Array<any>).map(TreeMapDataToJSON),
  };
}
